import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { Button } from '../Button';

export const Wrapper = styled.div`
  background: ${(props) => props.theme.color.light.default};
  border: 1px solid ${(props) => props.theme.color.light.tint};
  border-radius: 10px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  padding: 25px;
  padding-top: 0;
  position: relative;
  width: 100%;
  z-index: 5;
`;

export const Header = styled.div`
  background: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  border-radius: 10px 10px 0 0;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  margin: -1px -26px 10px;
  padding: 5px 25px;
  font-size: 16px;
  position: relative;
  &::after {
    border-color: ${(props) => props.theme.color.blue.default} transparent transparent;
    border-style: solid;
    border-width: 6px 6px 0;
    bottom: -6px;
    content: '';
    display: block;
    height: 0;
    left: 50%;
    margin-left: -6px;
    margin-top: 0;
    position: absolute;
    top: auto;
    transform: rotate(1turn);
    width: 0;
  }
`;

export const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${mediaQuery('phone')} {
    font-size: 15px;
  }
`;

export const HeaderSubitle = styled.div`
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${mediaQuery('phone')} {
    font-size: 15px;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
  position: relative;
`;

export const RoundedIcon = styled.div<{ active: boolean; last?: boolean }>`
  background: ${(props) => props.theme.color[props.active ? 'blue' : 'light'].default};
  color: ${(props) => props.theme.color[props.active ? 'light' : 'blue'].default};
  box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  right: -37px;
  top: 32px;
  font-size: 16px;
  font-weight: 700;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    ${(props) =>
      (props.last ?? false) === false &&
      props.active &&
      `
    background-color: ${props.theme.color.blue.default};
    content: '';
    height: 72px;
    position: absolute;
    top: 24px;
    width: 2px;
    left: 50%;
  `}
  }
`;

export const CalendarContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  padding: 10px 0;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
`;

export const CalendarOverlayWrapper = styled.div`
  position: absolute;
  background: rgba(197, 204, 214, 0.7);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
`;

export const CalendarOverlay = styled.div<{ clickable?: boolean }>`
  ${(props) => props.clickable && 'cursor: pointer;'}
  padding: 10px;
  font-weight: 700;
  background: ${(props) => props.theme.color.light.default};
  color: ${(props) => props.theme.color.blue.default};
  text-align: center;
  border-radius: 10px;
`;

export const CalendarArrowWrapper = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  padding: 6px;
  font-size: 16px;
  height: 52px;
  border-bottom: 2px solid ${(props) => props.theme.color.light.tint};
`;

export const CalendarColumn = styled.div`
  width: 80px;
`;

export const CalendarDayContainer = styled.div`
  height: 52px;
  font-weight: 600;
  text-align: center;
  font-size: 16px;
  border-bottom: 2px solid ${(props) => props.theme.color.light.tint};
  padding-bottom: 10px;
  margin-bottom: 10px;
`;

export const CalendarMonth = styled.div`
  font-weight: 400;
`;

export const CalendarHoursContainer = styled.div<{ showAllAvails?: boolean }>`
  min-height: 210px;
  ${(props) => (props.showAllAvails ? '' : 'max-height: 210px;')}
  overflow: hidden;
  text-align: center;
  transition: all 0.3s ease-in-out;
`;

export const CalendarHour = styled.div<{ selected?: boolean }>`
  background-color: rgba(91, 127, 225, 0.14);
  border-radius: 3px;
  color: #707070;
  cursor: pointer;
  font-size: 16px;
  margin: 10px;
  padding: 10px 0;
  transition: all 0.3s ease-in-out;
  ${(props) =>
    props.selected ? `background: ${props.theme.color.blue.default}; color: white;` : ''}
`;

export const PreBookingWarning = styled.div`
  padding: 10px 20px;
  background: ${(props) => props.theme.color.yellow.tint};
  border-radius: 10px;
  margin: 10px 0;
  p {
    margin: 0;
  }
`;

export const Label = styled.div`
  font-weight: 700;
`;

export const ShowMoreButton = styled(Button)`
  cursor: pointer;
  font-size: 16px;
  border: 1px;
  color: ${(props) => props.theme.color.blue.default};
  &:hover {
    color: ${(props) => props.theme.color.dark.default};
  }

  border-top: 2px solid ${(props) => props.theme.color.light.tint};
  border-radius: 0;
  width: 100%;
  margin: 0;
  margin-top: 10px;
`;
